import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter, browserHistory } from 'react-router';
import partial from 'lodash/partial';
import trailingSlashIt from 'trailing-slash-it';
import { getProjectUrl } from 'project/utils';
import { getProject } from 'project/ducks/project';
import { fetchRevisionComments, setHoveredRevisionComment } from 'presentations/ducks';
import RevisionResults from 'presentations/components/revision_results';

const mapStateToProps = (state, { params, location }) => {
  const { revisionId, subcategory, presentationId } = params;
  const {
    currentPresentation, hoveredRevisionCommentId, revisionComments, currentRevisions
  } = state.project.presentations;
  const project = getProject(state);
  const resultsUrl = getProjectUrl(
    project, subcategory, `presentations/${presentationId}/results/`
  );
  const showingComments = trailingSlashIt(location.pathname).endsWith('comments/');

  return {
    presentation: currentPresentation,
    revision: (currentRevisions || []).find(r => r.id === parseInt(revisionId)),
    inPlaceComments: (revisionComments || []).filter(c => !!c.percent_x),
    toggle: () => browserHistory.push(resultsUrl),
    hoveredCommentId: hoveredRevisionCommentId,
    showingComments
  };
}

const mapDispatchToProps = (dispatch, { params }) => {
  const { presentationId, revisionId } = params;

  return bindActionCreators({
    fetchComments: partial(fetchRevisionComments, presentationId, revisionId),
    setHoveredComment: setHoveredRevisionComment
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RevisionResults));



// WEBPACK FOOTER //
// ./presentations/containers/revision_results.js